module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Ladle-a01a9562f9ab18207906bc1ad01b1b8d.svg";